import type { LocalNotificationAdapter } from './types';

const expoLocalNotificationAdapter: LocalNotificationAdapter = {
  schedule: async () => {},
};

export { expoLocalNotificationAdapter };
